export function getCurrentDate() {

    let d = new Date();
    return d.getFullYear()
    +'-'
    +("0"+(d.getMonth()+1)).slice(-2)
    +'-'
    +("0"+d.getDate()).slice(-2)
}

export function getCurrentTime() {
    let d = new Date();
    // return d.getHours() + ':' + ("0"+(d.getMinutes())).slice(-2);
    return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
}

//Method to convert date format
export function getDisplayDate(dateString) {
    if (!dateString || typeof dateString !== 'string') {
        return '';
    }
    let dateParts = dateString.split("-");
    if (dateParts.length !== 3) {
        return dateString;
    }
    return dateParts[2] + "-" + dateParts[1] + "-" + dateParts[0];
}

export function formatDateForApi(value) {
    if (!value) {
        return '';
    }
    const raw = String(value).trim();
    if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) {
        return raw;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
        return getDisplayDate(raw);
    }
    return raw;
}
